import React from 'react';
import { FaClipboardList, FaCheckCircle, FaHourglassHalf, FaTimesCircle } from '../../Data/Icons';

const Home = () => {
	return (
		<div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mt-4 '>
			{/* Total Orders */}
			<div className=' shadow-md rounded-lg p-3 sm:p-2 flex justify-between bg-[#F3FDE8] mt-5 items-center w-[95%] mx-auto'>
				<FaClipboardList className='text-[#213555] text-xl sm:text-4xl md:ml-6' />
				<div className='text-right'>
					<h2 className='text-gray-600 text-xl sm:text-sm font-semibold md:mr-6'>Total Orders</h2>
					<p className='text-lg sm:text-3xl font-semi-bold text-gray-700 md:mr-6'>1200</p>
				</div>
			</div>

			{/* Completed Orders */}
			<div className='bg-[#F3FDE8] shadow-md rounded-lg p-3 sm:p-2 flex justify-between mt-5  items-center w-[95%] mx-auto'>
				<FaCheckCircle className='text-[#A9C46C] text-xl sm:text-4xlmd:ml-6' />
				<div className='text-right'>
					<h2 className='text-gray-600 text-xl sm:text-sm font-semibold md:mr-6'>
						Completed Orders
					</h2>
					<p className='text-lg sm:text-3xl font-semi-bold text-gray-700 md:mr-6'>950</p>
				</div>
			</div>

			{/* Pending Orders */}
			<div className='bg-[#F3FDE8] shadow-md rounded-lg p-3 sm:p-2 flex justify-between mt-5  items-center w-[95%] mx-auto'>
				<FaHourglassHalf className='text-yellow-500 text-xl sm:text-4xl md:ml-6' />
				<div className='text-right'>
					<h2 className='text-gray-600 text-lg sm:text-sm font-semibold md:mr-6'>Pending Orders</h2>
					<p className='text-lg sm:text-3xl font-semi-bold text-gray-700 md:mr-6'>180</p>
				</div>
			</div>

			{/* Canceled Orders */}
			<div className='bg-[#F3FDE8] shadow-md rounded-lg p-3 sm:p-2 flex justify-between mt-5  items-center w-[95%] mx-auto'>
				<FaTimesCircle className='text-red-500 text-3xl sm:text-4xl md:ml-6' />
				<div className='text-right'>
					<h2 className='text-gray-600 text-lg sm:text-sm font-semibold md:mr-6'>
						Canceled Orders
					</h2>
					<p className='text-lg sm:text-3xl font-semi-bold text-gray-700 md:mr-6'>70</p>
				</div>
			</div>
		</div>
	);
};

export default Home;
